import { useRouter } from 'next/router'
import { IoDocument } from 'react-icons/io5'

import { SectionHeader, InfiniteScroll, Container, SearchForm } from '~/src/components/shared'
import { BaseLayout } from '~/src/components/shared/layout'
import { PageMetaContext, PageMetaContextProvider } from '~/src/contexts'
import { usePostConnection } from '~/src/hooks/post/usePostConnection'
import { PostGrid, PostCoverType } from '~/src/components/post'
import { PageId } from '~/src/generated/graphql'
import { buildPostSearchQuery } from '~/src/utils'

export default function SearchPage() {
  const router = useRouter()
  const query = router?.query?.query as string

  const { posts, totalCount, fetchMore } = usePostConnection({
    where: buildPostSearchQuery(query),
    skip: !Boolean(query)
  })

  const hasItems = totalCount > 0

  return (
    <BaseLayout>
      <PageMetaContextProvider pageId={PageId.Search}>
        <Container>
          <div className="my-20">
            <SearchForm />
            <div className="mb-10" />
            <SectionHeader 
              title={`"${query}"의 검색결과`?? "검색어를 입력해주세요"}
              description={hasItems ? `"${query}" 키워드에 일치하는 검색결과 입니다.`: undefined}
              variant="primary"
            />
            <PageMetaContext.Consumer>
              {(page) => (
                <div className="mt-20">
                  {hasItems ? (
                    <>
                      <PostGrid
                        posts={posts}
                        coverType={PostCoverType.Square}
                        displayOption={page?.data?.displayOption ?? undefined} />
                      <InfiniteScroll fetchMore={fetchMore} />
                    </>
                  ): (
                    <div className="flex justify-center align-middle w-full text-gray-600">
                      <div className="inline-block">
                        <div className="mb-4 text-center">
                          <IoDocument
                            size={64}
                            className="inline-block" />
                        </div>
                        <span>"{query}"에 일치하는 검색결과가 없습니다.</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </PageMetaContext.Consumer>
          </div>
        </Container>
      </PageMetaContextProvider>
    </BaseLayout>
  )
}